<template>
<div>
    <v-dialog v-model="mostrar" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline">Número consecutivos</v-card-title>
        <v-card-text>
          <v-tabs
            v-model="consecutivos.tab"
            centered
            background-color="blue-grey"
            dark
            slider-color="yellow"
          >
            <v-tab href="#tab-SG">Secretaría General</v-tab>
            <v-tab href="#tab-CGU">Consejo General Universitario</v-tab>

            <v-tabs-items v-model="consecutivos.tab">
              <v-tab-item value="tab-SG">
                <v-card outlined>
                  <v-card-title
                    >Siguiente número automático:
                    {{ consecutivos.SG.consecutivo }}</v-card-title
                  >
                  <v-card-text>
                    Números no usados:
                    {{ consecutivos.SG.disponibles.toString() }}
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item value="tab-CGU">
                <v-card outlined>
                  <v-card-title
                    >Siguiente número automático:
                    {{ consecutivos.CGU.consecutivo }}</v-card-title
                  >
                  <v-card-text>
                    Números no usados:
                    {{ consecutivos.CGU.disponibles.toString() }}
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="blue-grey darken-1"
            outlined
            text
            @click="$emit('cancelar')"
            >Cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { consecutivoService} from "./oficiosGenerados.service";


export default {
 
  components: {
   
  },
  props:["mostrar"],
 
  data: () => ({
    loading: false,
     consecutivos: {
      tab: null,
      SG: { disponibles: [] },
      CGU: { disponibles: [] },
    },

    
   
  }),
  async created() {
    this.loading = true;
      try {
        const serverResponse = await consecutivoService();
        
        this.consecutivos.SG = serverResponse.SG;
        this.consecutivos.CGU = serverResponse.CGU;

        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$notificarError(error.message);
      }
   
  },

};
</script>